function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.92,4.08a10.49,10.49,0,1,0,0,14.84A10.51,10.51,0,0,0,18.92,4.08ZM12.55,15.71a1.05,1.05,0,0,1-2.1,0V11a1.05,1.05,0,0,1,2.1,0ZM11.47,8.52a1.08,1.08,0,1,1,1.08-1.08A1.08,1.08,0,0,1,11.47,8.52Z",
    style: {
      fill: "#663ea8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoActive);
export default __webpack_public_path__ + "static/media/ic-info-active.3989376e0b023fa0934bf251c735eb36.svg";
export { ForwardRef as ReactComponent };